import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext";
import CoursesTable from "../../components/Tables/CoursesTable";
import Select from "react-select";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import {
  getLocalDateFromString,
  shortDateTimeFormatter,
} from "../../utils/utils";
import { Button } from "../../components/StyledElements";
import { useCourseContext } from "../../contexts/CoursesContext";


const SmallButton = styled.div`
  height: 30px;
  width: 24px;
  background-color: #f3f4f6; 
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0a6b1;
  cursor: pointer;

  &.selected {
    background-color: var(--button-selected-bg); 
  }
  &.selected > * {
    color: var(--button-bg);

  }
`

const VerticalSeparator = styled.div`
  width: 1px;
  height: 30px;
  background-color: #eceff4;
  margin-left: 20px;
  margin-right: 20px;
`

const CoursesGridWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

`

const CourseCardWrapper = styled.div`
    position: relative;
    border: 1px solid var(--content-item-border-color);
    color: var(--main-font-color);
    width: 330px;
    background-color: var(--card-bg);
    border-radius: 5px;
    box-shadow: var(--content-item-box-shadow);
    padding: 20px 20px 0 20px;
`

const CourseTitle = styled.div`
    font-weight: bold;
    font-size: 20px;
    margin-top: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
    text-wrap: wrap;
`

const CourseDescription = styled.div`
    font-weight: normal;
    font-size: 16px;
    margin-top: 10px;
    font-style: italic;
    overflow: auto;
    max-height: 140px;
    height: 140px;
    margin-bottom: 10px;
`

const CourseInfo = styled.div`
    font-size: 15px;
    margin-bottom: 10px;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;

    & > div {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
}
`
const CourseData = styled.div`
    position: relative;
    width: 330px;
    margin-left: -20px;
    font-size: 14px;
    color: #a0a6b1;
    background-color: var(--card-inset-bg);
    padding: 10px 20px;
    border-top: 1px solid var(--main-bg);
    border-bottom: 1px solid var(--main-bg);
`;

const CourseOpenLink = styled.a`
    font-size: 15px;
    color: var(--sidebar-active-item-color);
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
`;

const SearchBar = styled.div`
  width: calc(100% - 20px);
  border-radius: 5px;
  border: 1px solid var(--content-item-border-color);  
  background-color: var(--card-bg);
  padding: 10px 20px;
  box-shadow: var(--content-item-box-shadow);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`

const SearchBox = styled.div`
  width: 300px;
  height: 36px;
  border-radius: 5px;
  border: 1px solid #d2d6dd;
  background-color: #f8fafb; 
  display: flex;
  align-items: center;
  padding-left: 10px;

  & * {
    color: #717886;
  }

  & input {
    height: 100%;
    border: none;
    outline: none !important;
    background: transparent;
    width: 250px;
  }

  & input:focus {
    outline:none !important;
    outline-width: 0 !important;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }
}
`

const CourseToolBarWrapper = styled.div`
  width: 300px;
  margin-left: -20px;
  height: 50px;
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: nowrap;
  padding: 0;
`

const CourseToolBarButton = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--main-bg);
  cursor: pointer;

  & * {
    font-size: 20px;
 }

`;

export const Courses = () => {
  const { activeUser } = useAuthContext();
  const isAdmin = activeUser?.user_type.includes("admin");
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("newest-first")
  const [display, setDisplay] = useState("grid");
  const navigate = useNavigate();

  const { courses, setCourses } = useCourseContext();

  const sortByOptions = [
    { label: "Newest First", value: "newest-first" },
    { label: "Open Date First", value: "open-date-first" },
    { label: "Open Date Last", value: "open-date-last" },
    { label: "Start Date First", value: "start-date-first" },
    { label: "Start Date Last", value: "start-date-last" },
  ]

  useEffect(() => {
    console.log("!!! FETCHING COURSES");
    setFilteredCourses(courses || []);

    // eslint-disable-next-line
  }, [courses]);


  useEffect(() => {
    if (!searchTerm) {
      setFilteredCourses(courses);
      return;
    }

    setFilteredCourses(courses.filter((course) => {
      console.log(course.title, course.description)
      return `${course.status} ${course.title} ${course.description}`.toLowerCase().includes(searchTerm.toLowerCase())
    }))

    // eslint-disable-next-line
  }, [searchTerm, courses])

  const CourseToolBar = ({ course }) => {
    return (
      <CourseToolBarWrapper>
        {/* Toolbar buttons can be added here */}
        <CourseToolBarButton><Icon icon="mdi:link" /></CourseToolBarButton>
        {/*/<CourseToolBarButton
          onClick={() => {
            swal.fire({
              title: "Are you sure?",
              text: "This will permanently delete the live event and all associated data.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Yes, delete it!"
            }).then(async (result) => {
              console.log("!!! SWEET ALERT RESULT: ", result);
              if (result.value) {
                const response = await deleteCourse(course.public_id)
                console.log("!!! DELETE LIVE EVENT RESPONSE: ", response);
                if (response.success) {
                  console.log("!!!! LIVE EVENT DELETED SUCCESSFULLY: ", course.public_id);
                  setCourses(courses.filter((le) => le.public_id !== course.public_id));
                  swal.fire({
                    title: 'Deleted!',
                    text: 'The live event has been deleted.',
                    icon: 'success'
                  });
                } else {
                  swal.fire({
                    title: 'Error!',
                    text: 'There was an error deleting the live event. Please try again.',
                    icon: 'error'
                  });
                }
              }
            });
          }}
        ><Icon icon="mdi:trash-can" /></CourseToolBarButton>
*/}
      </CourseToolBarWrapper>
    )
  }

  const getCourseStatus = (course) => {
    const now = new Date();
    const startDate = getLocalDateFromString(course.start_date);
    const endDate = getLocalDateFromString(course.completed_at);

    if ((course.status === "scheduled" || (startDate && startDate > now)) || (course.status === "initialized" && course.event_type.includes("recorded", "scheduled"))) {
      return "scheduled";
    }

    if (course.status === "ended" || (endDate && endDate < now)) {
      return "ended";
    }

    return course.status
  }

  const CourseCard = ({ course }) => {
    const courseStatus = getCourseStatus(course);
    return (
      <CourseCardWrapper key={course.id}>
        <div style={{ height: "240px", minHeight: "240px" }}>
          <CourseTitle
            title={course.title}
          >{course.title}</CourseTitle>
          <CourseDescription>{course.description ?? "No event description"}</CourseDescription>
        </div>
        {courseStatus === "ended" &&
          (
            <>
              <CourseInfo>
                <Icon icon="mdi:calendar-blank" />
                <div style={{ marginLeft: "10px" }}>Started: {course?.start_date ? shortDateTimeFormatter.format(getLocalDateFromString(course.start_date)) : "-"}</div>
              </CourseInfo>
              <CourseInfo>
                <Icon icon="mdi:clock" />
                <div style={{ marginLeft: "10px" }}>Ended: {course?.completed_at ? shortDateTimeFormatter.format(getLocalDateFromString(course.completed_at)) : "-"}</div>
              </CourseInfo>
              <CourseInfo>
                <Icon icon="mdi:people" />
                <div style={{ marginLeft: "10px" }}>{course.participant_count} users</div>
              </CourseInfo>
            </>
          )
        }

        {courseStatus === "scheduled" &&
          (
            <>
              <CourseInfo>
                <Icon icon="mdi:calendar" color={"var(--sidebar-active-item-color)"} style={{ fontWeight: "500" }} />
                <div style={{ marginLeft: "10px", fontWeight: "500" }}>Opens: {course.open_date ? shortDateTimeFormatter.format(getLocalDateFromString(course.open_date)) : "-"}</div>
              </CourseInfo>
              <CourseInfo>
                <Icon icon="mdi:clock" />
                <div style={{ marginLeft: "10px" }}>Starts: {course.start_date ? shortDateTimeFormatter.format(getLocalDateFromString(course.start_date)) : "-"}</div>
              </CourseInfo>
              <CourseInfo>
                <Icon icon="mdi:people" />
                <div style={{ marginLeft: "10px" }}>{course.participant_count} users</div>
              </CourseInfo>
            </>
          )
        }

        <CourseData>
          <div>ID: {course.id}</div>
          <div>PUB: {course.public_id.substr(0, 8)}...</div>
          <div style={{ position: "absolute", right: "20px", top: "10px", fontSize: "12px", color: "#a0a6b1" }}>
            <CourseOpenLink onClick={() => {
              const { public_id } = course;
              navigate(`/course/${public_id}`);
            }}>
              View <Icon icon="mdi:open-in-new" style={{ marginLeft: "5px" }} />
            </CourseOpenLink>
          </div>
        </CourseData>
        <CourseToolBar course={course} />
      </CourseCardWrapper>
    )
  }

  const CoursesGrid = () => {
    console.log("!!! FILTERED COURSES: ", filteredCourses);
    return (
      <CoursesGridWrapper>
        {filteredCourses.map(course => {
          return <div key={course.id} style={{ marginRight: "24px", marginBottom: "24px" }}><CourseCard course={course} /></div>
        })
        }
      </CoursesGridWrapper>
    );
  }

  return (
    <div style={{ marginLeft: "20px" }}>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        <div style={{ color: "var(--main-font-color)" }}>Courses <span style={{ fontSize: "16px", color: "gray", fontWeight: "normal" }}>({courses.length > filteredCourses.length ? `${filteredCourses.length} of ${courses.length}` : courses.length})</span></div>
        <div style={{ fontSize: "16px", color: "gray", fontWeight: "normal" }}>Manage courses</div>
      </div>
      {
        isAdmin && (
          <div style={{ position: "absolute", right: "20px", top: "10px", display: "flex", flexDirection: "row", gap: "10px" }}>

            <Button
              onClick={() => {
                navigate(`/course/create`);
              }}
            >+ Create Course</Button>

            <Button
              onClick={() => {
                navigate(`/course/generate`);
              }}
            >+ Generate Course</Button>
          </div>
        )}

      <div style={{ marginTop: "24px" }}>
        <SearchBar>
          <label style={{ marginRight: "10px", color: "var(--main-font-color)" }}>Sort by: </label>
          <Select
            label="Sort by"
            placeholder="Sort By"
            name="sortby"
            value={
              sortByOptions.find(
                (sb) =>
                  sb.value === sortBy
              )
            }
            options={sortByOptions}
            onChange={(e) => {
              setSortBy(e.value);
            }}
          />
          <VerticalSeparator />

          <SmallButton className={display === "list" ? "selected" : ""} style={{ marginRight: "10px" }}
            onClick={() => { setDisplay("list") }}>
            <Icon icon="material-symbols:list" />
          </SmallButton>
          <SmallButton className={display === "grid" ? "selected" : ""} style={{ marginRight: "10px" }}
            onClick={() => { setDisplay("grid") }}>
            <Icon icon="material-symbols:grid-view-outline" />
          </SmallButton>
          <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <SearchBox>
              <Icon icon="material-symbols:search" />
              <input value={searchTerm} type="text" onChange={(e) => {
                setSearchTerm(e.target.value);
              }} />

              {searchTerm &&
                <div style={{ cursor: "pointer" }} onClick={() => setSearchTerm("")}>
                  <Icon icon="material-symbols:x-circle" />
                </div>
              }
            </SearchBox>
          </div>
        </SearchBar>
      </div>

      {
        display === "grid" &&
        <div style={{ marginTop: "24px" }}>
          <CoursesGrid />
        </div>
      }
      {
        display === "list" &&
        <CoursesTable
          courses={filteredCourses}
          onUpdated={(newCourses) => {
            setCourses(newCourses);
          }}
        />
      }
    </div>
  );
};

export default Courses;
